import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { InfoOutlined } from "@mui/icons-material";
import { Stack } from "@/Components/v2/atoms/Stack";
import dayjs from "dayjs";

const DataRecencyBanner = ({ date }: { date: dayjs.Dayjs }) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.infoBanner.background,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2,
        borderRadius: 2,
      })}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <InfoOutlined sx={(theme) => ({ color: theme.palette.infoIcon.color, fontSize: 24 })} />

        <Typography variant="body2" fontWeight={600} mb={0.5}>
          Action Plans are current up to {dayjs(date).format("DD MMM YYYY")}.
        </Typography>
        <Typography variant="body2">Some things may have changed.</Typography>
      </Stack>
    </Box>
  );
};

export default DataRecencyBanner;
